// extracted by mini-css-extract-plugin
export default {"tabbar":"TabBar_tabbar__MSdDx","item":"TabBar_item__PsK+8","icon":"TabBar_icon__ea09Z","label":"TabBar_label__14AYj","active":"TabBar_active__D4eBG"};